import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import LineChart from "../charts/generic/LineChart"
import DoughnutChart from "../charts/generic/DoughnutChart"
import ChartComparison from "../ChartComparison"
import EngagementScoreFullWidthDataShape from "../../state/shapes/EngagementScoreFullWidthDataShape"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function EngagementScoreFullWidth({
  exportEndpoint,
  appliedFilters,
  data,
  subtitleKey,
  sampleSize,
  t
}) {
  const formatTooltip = (context) => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }

    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  const engagementCategories = data.overTime.map(x => x.month)
  const series = data.overTime.map(x => ({ y: x.engagementPercentage, count: x.responses }))

  const engagementScoreData = [
    {
      name: null,
      data: series
    }
  ]

  const hasComparisonData = false //! !(data.averages[1] && data.averages[1].value)
  const titleKey = "Widgets.EngagementScore.Title"
  return (
    <Widget
      columns={3}
      titleKey={titleKey}
      helpKey="Widgets.EngagementScore.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <LineChart
        columns={2}
        data={engagementScoreData}
        categories={engagementCategories}
        chartPointStart={0}
        xAxisLabel="Common.Time"
        xTickInterval={1}
        yAxisLabel="Common.Percentage"
        yMinValue={0}
        yMaxValue={100}
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
      {data.averages &&
        data.averages.length > 0 && (
          <DoughnutChart
            columns={1}
            data={data.averages}
            suffix="%"
            chartThreshold={null}
            hasComparison={hasComparisonData}
            titleKey={titleKey}
            labelKey="Common.Average"
            subtitleKey={subtitleKey}
          >
            {hasComparisonData && (
              <ChartComparison
                baseValue={data.averages[0].value}
                comparisonOneValue={
                  data.averages[1] && data.averages[1].value ? data.averages[1].value : null
                }
                comparisonOneText="Common.LastSixMonths"
                comparisonTwoValue={
                  data.averages[2] && data.averages[2].value ? data.averages[2].value : null
                }
                comparisonTwoText="Common.LastTwelveMonths"
                usePercentage
                increaseIsGood
                translateText
              />
            )}
          </DoughnutChart>
        )}
    </Widget>
  )
}

EngagementScoreFullWidth.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  data: PropTypes.shape(EngagementScoreFullWidthDataShape).isRequired,
  t: PropTypes.func.isRequired,
  sampleSize: PropTypes.object
}

EngagementScoreFullWidth.defaultProps = {
  subtitleKey: null
}

export default translate()(EngagementScoreFullWidth)



// WEBPACK FOOTER //
// ./src/components/widgets/EngagementScoreFullWidth.jsx